import { DatePipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

const getLocalDateTime = (date: any, format = 'short') => {
    return new DatePipe('en-US')
        .transform(date, format);
};

export const ENV: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
const userProfile: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

const DEFAULT_ENV = 'DEV';

/**
 * Sets environment using environment-settings.json endpoint.
 */
export const setEnv = () => {
    const currentUrl = window.location.hostname;
    const url = `assets/config.json`;
    const http = new XMLHttpRequest();
    http.open('GET', url);
    http.send();
    http.onreadystatechange = (e) => {
        if (http.readyState === XMLHttpRequest.DONE) {
            let environment = DEFAULT_ENV;
            if (http.status === 200) {
                const response = JSON.parse(http.responseText);
                if (response?.env && !response.env.includes('#')) { environment = response.env; }
            } else if (!currentUrl.includes('localhost')) { environment = ''; } // App Deployed
            ENV.next(environment);
        }
    };
};

export const getEnv = () => ENV.value;

export const utilities = {
    getEnv,
    getLocalDateTime
};


export const getUserProfile = (): any => {
    return userProfile.value;
};

export const setUserProfile = (profile): any => {
    return userProfile.next(profile);
};
